import ServerService from "../services/ServerService";
import { useConversationStateContext, useConversationDispatchContext } from "../context/ConversationContext";

function VariableAction () {
    const { requestVariableForServer } = ServerService
    const { backEndService, bot, session, data, company } = useConversationStateContext();
    const { variables } = data;
    const dispatch = useConversationDispatchContext();

    const deleteVariable = (name) => {
        const content = { method: 'delete', body : { name }};
        if(session) {
            content.body.session = session;
        }

        requestVariableForServer({ backEndService, company, bot}, content)
        dispatch({type : 'setVariables', payload : { variables : variables.filter(variable => variable.name != name)}});
    }

    const updateVariable = (name, value) => {
        const data = { name, value : value.trim() };
        const content = { method: 'put', body : data};
        if(session) {
            content.body.session = session;
        }

        requestVariableForServer({ backEndService, company, bot}, content)
        dispatch({type : 'setVariables', payload : { variables : variables.map(variable => variable.name == name ? {...variable, ...data} : variable)}});
    }

    const deleteAllVariable = () => {
        const content = { method: 'delete', body : {}};
        if(session) {
            content.body.session = session;
        }

        requestVariableForServer({ backEndService, company, bot}, content)
        dispatch({type : 'setVariables', payload : { variables : []}});
    }

    return { deleteVariable, deleteAllVariable, updateVariable }
}

export default VariableAction;